import i18n from "i18next";
import { initReactI18next } from "react-i18next";

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: require("./locales/en.json"),
    },
    de: {
      translation: require("./locales/de.json"),
    },
  },
  lng: "de", // Default to German
  fallbackLng: "de",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
